import React from 'react';
import { SectionWrapper, FadeIn } from './Shared';
export const PainPoints = () => {
  const points = [{
    icon: '😣',
    text: 'Te despertás hinchada sin razón clara'
  }, {
    icon: '👖',
    text: 'Tu ropa te aprieta aunque no hayas comido de más'
  }, {
    icon: '🍽',
    text: 'Sentís pesadez después de casi cualquier comida'
  }, {
    icon: '😓',
    text: 'Probaste “comer sano” pero no ves cambios'
  }, {
    icon: '⚡',
    text: 'Tenés poca energía durante el día'
  }, {
    icon: '😤',
    text: 'Tu abdomen cambia constantemente (plano → hinchado)'
  }, {
    icon: '💊',
    text: 'Dependés de soluciones rápidas que no resuelven nada'
  }, {
    icon: '😔',
    text: 'No entendés qué le pasa realmente a tu cuerpo'
  }];
  return <SectionWrapper className="bg-cream-dark" data-id="element-112">
      <div className="max-w-4xl mx-auto" data-id="element-113">
        <FadeIn data-id="element-114">
          <div className="text-center mb-8 md:mb-12" data-id="element-115">
            <span className="text-rose font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-116">
              ❗ Esto es para vos si...
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-sage-900 mb-4" data-id="element-117">
              ¿Te sentís identificada con alguna de estas situaciones?
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-12" data-id="element-118">
          {points.map((point, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-119">
              <div className="flex items-start space-x-4 bg-white p-5 rounded-2xl shadow-card border border-slate-100" data-id="element-120">
                <span className="text-2xl flex-shrink-0" data-id="element-121">{point.icon}</span>
                <p className="text-slate-700 font-medium leading-snug pt-1" data-id="element-122">
                  {point.text}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-123">
          <div className="bg-sage-700 text-white p-6 md:p-8 rounded-2xl text-center shadow-soft" data-id="element-124">
            <p className="text-xl md:text-2xl font-serif font-medium" data-id="element-125">
              ✅ Si te identificás con al menos una,{' '}
              <span className="font-bold text-sage-200" data-id="element-126">
                Deshinchate es para vos.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </SectionWrapper>;
};